import _ from 'lodash';
import React from 'react';

function useDebounce(callback, ms = 300) {
  return React.useMemo(() => _.debounce(callback, ms), [callback, ms]);
}

export default useDebounce;
